import { EmailHeartOutlineIcon } from './EmailHeartOutlineIcon';

/**
 * author: Jeff Anders
 * id 763A453D-9B1C-4E6A-A28C-2534AD4641A7
 * name email-heart-outline
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/email-heart-outline.svg
 * tags
 */
export const EnvelopeHeartOutlineIcon = EmailHeartOutlineIcon;
export default EnvelopeHeartOutlineIcon